import { motion } from "framer-motion";
import { useLiveStatus } from "../hooks/useLiveStatus";

export const LiveBadge = ({ size = "md", showLabel = true, className = "" }) => {
    const { isLive, loading } = useLiveStatus();

    const dotSize = size === "sm" ? "h-1.5 w-1.5" : "h-2 w-2";
    const text = size === "sm" ? "text-[10px]" : "text-xs";

    if (loading) {
        return (
            <div className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-white/5 border border-white/10 ${className}`} data-testid="live-badge-loading">
                <span className={`${dotSize} rounded-full bg-white/30 animate-pulse`} />
                {showLabel && <span className={`${text} uppercase tracking-wider text-white/40 font-medium`}>Checking</span>}
            </div>
        );
    }

    if (!isLive) {
        return (
            <div className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-white/5 border border-white/10 ${className}`} data-testid="live-badge-offline">
                <span className={`${dotSize} rounded-full bg-white/30`} />
                {showLabel && <span className={`${text} uppercase tracking-wider text-white/50 font-medium`}>Offline</span>}
            </div>
        );
    }

    return (
        <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-red-500/15 border border-red-500/40 ${className}`}
            data-testid="live-badge-live"
        >
            <span className="relative flex items-center justify-center">
                <span className={`absolute ${dotSize} rounded-full bg-red-500/60 animate-ping`} />
                <span className={`relative ${dotSize} rounded-full bg-red-500`} />
            </span>
            {showLabel && <span className={`${text} uppercase tracking-wider text-red-300 font-bold`}>Live</span>}
        </motion.div>
    );
};
